export const ROLE_SHOW_RESET = 'ROLE_SHOW_RESET'
export const ROLE_SHOW_SET_ERROR = 'ROLE_SHOW_SET_ERROR'
export const ROLE_SHOW_SET_RETRIEVED = 'ROLE_SHOW_SET_RETRIEVED'
export const ROLE_SHOW_TOGGLE_LOADING = 'ROLE_SHOW_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/role/show/mutation_types.js